const courses = [
  {
    title: "Artificial Intelligence & Machine Learning",
    slug: "ai-machine-learning",
    image:
      "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=500&h=300&fit=crop",
    badge: "Most Popular",
    duration: "3 Months",
    level: "Beginner to Advanced",
    description:
      "Learn AI and Machine Learning including deep learning, NLP, and computer vision with real-world projects.",
    features: [
      "Python, TensorFlow & PyTorch",
      "Neural Networks & Deep Learning",
      "NLP & Computer Vision",
      "Real-world AI Projects",
    ],
  },
  {
    title: "Full Stack Web Development",
    slug: "fullstack-web-development",
    image:
      "https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=500&h=300&fit=crop",
    badge: "Full Stack",
    duration: "3 Months",
    level: "Beginner to Advanced",
    description:
      "Become a full stack developer using modern technologies like React, Node.js, and MongoDB.",
    features: [
      "HTML, CSS, JavaScript & React",
      "Node.js & Express",
      "MongoDB Database",
      "Real-world Web Projects",
    ],
  },
  {
    title: "Cybersecurity Fundamentals",
    slug: "cybersecurity",
    badge: "IN-DEMAND SKILLS",
    description:
      "Learn to protect systems, networks, and data from cyber threats. Master ethical hacking, penetration testing, and security auditing.",
    duration: "3 Months",
    level: "Beginner to Intermediate",
    features: [
      "Ethical hacking & penetration testing",
      "Network & system security",
      "Security auditing & compliance",
    ],
    image:
      "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=700&h=500&fit=crop",
  },
  {
    title: "UI/UX Design Mastery",
    slug: "ui-ux-design",
    image:
      "https://images.unsplash.com/photo-1586717791821-3f44a563fa4c?w=700&h=500&fit=crop",
    badge: "Creative Program",
    duration: "3 Months",
    level: "Beginner Friendly",
    description:
      "Design beautiful, user-centered digital experiences. Learn user research, wireframing, prototyping in Figma, and build a portfolio that gets you hired.",
    features: [
      "User Research, Personas & Journeys",
      "Wireframing & Prototyping in Figma",
      "High-Fidelity UI Design",
      "Portfolio Projects & Case Studies",
    ],
  },
  {
    title: "Graphic Designing",
    slug: "graphic-designing",
    image:
      "https://images.unsplash.com/photo-1626785774573-4b799315345d?w=700&h=500&fit=crop",
    badge: "Creative Program",
    duration: "3 Months",
    level: "Beginner Friendly",
    description:
      "Turn your creative vision into stunning visuals. Master Photoshop, Illustrator, and learn to create logos, brand identities, social media graphics, and print-ready designs.",
    features: [
      "Adobe Photoshop & Illustrator mastery",
      "Logo & Brand Identity Design",
      "Social Media & Marketing Graphics",
      "Portfolio-Ready Projects",
    ],
  },

  {
    title: "Data Science & Analytics",
    slug: "data-science",
    image:
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=700&h=500&fit=crop",
    badge: "Analytics Program",
    duration: "3 Months",
    level: "Beginner to Intermediate",
    description:
      "Unlock the power of data. Learn Python, statistical analysis, data visualization, SQL, and business intelligence to make data-driven decisions that matter.",
    features: [
      "Python & Jupyter Notebook",
      "Pandas, NumPy & Data Analysis",
      "SQL & Database Management",
      "Data Visualization with Power BI & Tableau",
      "Real-world Projects & Portfolio",
    ],
  },
];

export default courses;
